import { submitFavoriteDances } from "../api.js";

export async function submitVotes(eventId, { dancerId, occurrenceDate, voteeIds }) {
  return submitFavoriteDances(eventId, { dancerId, occurrenceDate, voteeIds });
}
